/**
 * 14 stub pages — each renders the generic StubPage with the data from
 * settings/navItems.ts plus a few specialized variants (LocalePage shows
 * the read-only Phase 0 defaults; IntegrationsHubPage shows the future
 * connector chips).
 */

import { Globe } from 'lucide-react';

import { StubPage } from './StubPage';
import { SETTINGS_NAV } from './navItems';
import styles from './settings.module.css';

function findItem(id: string) {
  const item = SETTINGS_NAV.find((it) => it.id === id);
  if (!item) throw new Error(`settings nav item missing: ${id}`);
  return item;
}

// ---- Account ---------------------------------------------------------------

export function SecurityPage() {
  const item = findItem('security');
  return (
    <StubPage
      title={item.label}
      sub="ניהול 2FA, sessions פעילים, API tokens ו-webhooks."
      phase={item.phase}
      icon={item.icon}
      body={item.description ?? ''}
    />
  );
}

// NotificationsPage moved to NotificationsPrefsPage.tsx (now live).

// ---- Business --------------------------------------------------------------

export function LocalePage() {
  const rows: { label: string; value: string }[] = [
    { label: 'שפת ממשק', value: 'עברית · he-IL' },
    { label: 'מטבע ראשי', value: 'ILS · ₪' },
    { label: 'אזור זמן', value: 'Asia/Jerusalem (GMT+3)' },
    { label: 'פורמט תאריך', value: 'DD/MM/YYYY' },
    { label: 'פורמט שעה', value: '24h' },
  ];
  return (
    <>
      <div className={styles.pageHead}>
        <h1>שפה ומטבע</h1>
        <p className={styles.pageSub}>ב-Phase 0 הערכים נעולים. עריכה ב-Phase 1.</p>
      </div>

      <div className={styles.stubCard}>
        <div className={styles.stubIcon} aria-hidden="true">
          <Globe size={48} />
        </div>
        <span className={styles.stubPhase}>זמין ב-Phase 1</span>
        <p className={styles.stubBody}>הגדרות הלוקליזציה הנוכחיות:</p>

        <div className={styles.localeGrid}>
          {rows.map((r) => (
            <div key={r.label} className={styles.localeCell}>
              <span className={styles.localeLabel}>{r.label}</span>
              <span className={styles.localeValue}>{r.value}</span>
            </div>
          ))}
        </div>
      </div>
    </>
  );
}

// AuditLogPage moved to its own file (now live, not stub).

export function DataExportPage() {
  const item = findItem('data');
  return (
    <StubPage
      title={item.label}
      sub="ניהול הנתונים שלך · ייצוא, גיבוי ומחיקת חשבון."
      phase={item.phase}
      icon={item.icon}
      body={item.description ?? ''}
    />
  );
}

// ---- Integrations Hub ------------------------------------------------------

// IntegrationsHubPage moved to IntegrationsPage.tsx (now live).

// ---- Catalogs --------------------------------------------------------------

function CatalogStub({ id }: { id: string }) {
  const item = findItem(id);
  return (
    <StubPage
      title={item.label}
      phase={item.phase}
      icon={item.icon}
      body={item.description ?? ''}
    />
  );
}

export function CatalogServicesPage() { return <CatalogStub id="cat-services" />; }
export function CatalogPipelinePage() { return <CatalogStub id="cat-pipeline" />; }
// CatalogSourcesPage / CatalogTagsPage / CatalogTeamPage moved to their own files (now live).
export function CatalogFieldsPage() { return <CatalogStub id="cat-fields" />; }
export function CatalogTemplatesPage() { return <CatalogStub id="cat-templates" />; }
export function CatalogInvoicePage() { return <CatalogStub id="cat-invoice" />; }
